import React from "react";
import BlogsCarousel from "./BlogsCarousel/BlogsCarousel";

export default function SuggestedModule() {
  return (
    <div className="blog_carousel_container">
      <BlogsCarousel />
    </div>
  );
}
